module.exports = __webpack_public_path__ + "img/adulto28.beb1c4c4.jpg";